import { render, staticRenderFns } from "./Self-care.vue?vue&type=template&id=4a15c7ac"
import script from "./Self-care.vue?vue&type=script&lang=js"
export * from "./Self-care.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports